import request from '@/utils/request'

// 查询热门搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/search/hot/keywords/page',
        method: 'get',
        params: query,
    })
}
// 查询热门搜索详细
export function getObj(id) {
    return request({
        url: '/upkeep/search/hot/keywords/detail?id=' + id,
        method: 'get',
    })
}
// 新增热门搜索
export function addObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/add',
        method: 'post',
        data: data,
    })
}
// 修改热门搜索
export function putObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/edit',
        method: 'post',
        data: data,
    })
}
// 删除热门搜索
export function delObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/delete',
        method: 'post',
        data: data,
    })
}
